module.exports = __webpack_public_path__ + "images/emoji/on.2fdc2c4a898ef4ec4c27.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/on.png
// module id = rntq
// module chunks = 1